/**
 * A function to allow us to guard modules that should be imported only once, not to be imported
 * multiple times.
 */
export function throwIfAlreadyLoaded(parentModule: unknown, moduleName: string): void {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import ${moduleName} modules in the AppModule only.`);
  }
}
